import { useState, useContext, useEffect } from 'react';
import { StateContext, DispatchContext } from './App';
import { dispatchFilterUpdate, dispatchSubheaderTextUpdate, dispatchArticlesData, dispatchUserSelections } from './functions/functions';

import ErrorBoundry from './ErrorBoundry';
import Header from './components/1_Header/Header';
import NavBar from './components/2_NavBar/NavBar';
import SubHeader from './components/3_SubHeader/Subheader';
import Gallery from './components/4_Gallery/Gallery';
import ConfigManager from './components/5_ConfigManager/ConfigManager';
import DialogWindow from './components/DialogWindow/DialogWindow';

import './RodaApp.css';

const RodaApp = () => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);
    const { init } = appState.appSettings.filter;
    const { production, isAppActive, subheaderText, isArticleSelected } = appState.appSettings;
    const [ activeFilter, setActiveFilter ] = useState(init);
    const [ scrollTop, setScrollTop ] = useState(0);

    let defaultSubheaderText = {
        info: null,
        title: null,
        note: ''
    };

    const [ subheaderTextInput, setSubheaderTextInput ] = useState(subheaderText);
    const [ _isArticleSelected, _setIsArticleSelected ] = useState(false);
    const [ composition, setComposition ] = useState(false);
    const [ articlesIDs, setArticlesIDs ] = useState([]);
    // const [ collectionID, setCollectionID ] = useState();
    const [ collectionName, setCollectionName ] = useState({name: ''});
    const [ articles, setArticles ] = useState();
    const [ hasError, setHasError ] = useState(false);
    
    const updateFilter = (id) => {
        setActiveFilter(id);
        dispatchFilterUpdate(dispatch, 'init', id);
        dispatchSubheaderTextUpdate(dispatch, {...defaultSubheaderText, note: `${id}_note`})
        // switch (id) {
        //     case 'collections' : setSubheaderTextInput( {...subheaderTextInput, note: 'collections_note'}); break;
        //     case 'categories'    : setSubheaderTextInput( {...subheaderTextInput, note: 'categories_note'}); break;
        //     default: throw new Error (`no matching id for ${id}`);
        // };
    };

    const updateScrollTop = () => {
        setScrollTop(document.getElementById('body').scrollTop);
    };

    useEffect(() => {
        if (isArticleSelected) {
            _setIsArticleSelected(true)
        } else {
            _setIsArticleSelected(false)
        };
    }, [isArticleSelected]);

    // useEffect(() => {
    //     let fetching = true;
    //     const getCollections = async () => {
    //         let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';
    //         await fetch(`${proxy}https://rodabackend.com/api/v1/collections/`)
    //         .then(res => res.json())
    //         .then(data => {
    //             if (data !== 'Mocked API not configured') {
    //                 if (fetching) {
    //                     if (data.length > 0 || data !== undefined) {
    //                         setCollectionName(data.filter(i => i.id === collectionID)[0].name)
    //                     } else {
    //                         console.error('there is something wrong with collection API')
    //                     }
                        
    //                 }
    //             }
    //         })
    //     };
    //     getCollections();
        
    //     return () => {
    //         fetching = false;
    //     }
    // }, [collectionID])

    useEffect(() => {
        let fetching = true;

        const fetchUserComposition = async (url) => {
            let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';
            setComposition(false);
            await fetch(`${proxy}http://rodabackend.com/mocked_api/v1/${url}/`)
            .then(res => res.json())
            .then(data => {
                if (data !== 'Mocked API not configured') {
                    if (fetching) {
                        console.log(data);
                        setHasError(false);
                        setComposition(true);
                        setCollectionName(prevState => ({...prevState, name: data.collectionName}) );
                        let ids = []; //array with current composition articles
                        data.articles.forEach(article => {
                            ids.push(article.id);
                            dispatch({
                                type:  'SET_USER_SELECTIONS',
                                payload: {itemID: article.item_id, prop: 'all', value: data}
                            });
                        }); 
                        
                        setArticlesIDs(ids);
                        // dispatchUserSelections(dispatch, )
                        
                        // dispatch({
                        //     type: 'SET_COMPOSITION',
                        //     payload: data
                        // })
                       

                        if (data.design && data.collectionName !== undefined) {
                            dispatchSubheaderTextUpdate(dispatch, {
                                info: data.designer,
                                title: data.collectionName,
                                note: null
                            });
                        }; 
                    };
                } else {
                    setComposition(false);
                    setHasError(true);
                    console.error('Mocked API not configured');
                }
            })
            .catch(error => {
                console.log(error); 
            }); 
        };

        let queryPath = window.location.pathname.substring(1);
        
        if (queryPath === 'share') {
            _setIsArticleSelected(true);
            dispatch({
                type: 'TOGGLE_IS_ARTICLE_SELECTED',
                payload: true
            });
            dispatch({
                type: 'SET_IS_SHARED',
                payload: true
            });
            let queryString = window.location.search.substring(1);
            console.log(queryString)
            if(queryString === '') {
                throw 'no encryption key given'
            };
            
            let ampersandPos = queryString.indexOf('&');
            if(ampersandPos > -1) {
                queryString = queryString.substring(0, ampersandPos)
            };
            let url = `share?${queryString}`
            fetchUserComposition(url);
            
            // 
        };
        
        return () => {
            fetching = false;
        };
    }, []);

    useEffect(() => {
        if (composition) {
            production ? window.history.replaceState({}, document.title, `/`) : window.history.replaceState({}, document.title, `/`);
        };
    }, [composition])

    useEffect(() => {
        let fetching = true;
        let isFetchingCompleted = false;
        let _articles = [];
        const userArticle = [];
        let design = ''; // designer info

        const fetchArticlesData = async (id) => {
            let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';
            await fetch(`${proxy}http://rodabackend.com/mocked_api/v1/articles/${id}/`)
            .then(res => res.json())
            .then(data => {
                if (data !== 'Mocked API not configured') {
                    if (fetching) {
                        console.log('data', data)
                        data.item_id = data.id; 
                        _articles.push(data);
                        dispatchArticlesData(dispatch, _articles);
                        userArticle.push({
                            item_id: data.item_id,
                            id: data.id,
                            collection: data.collection,
                            options: undefined
                        });
                        
                        // if (design !== '' && data.design !== undefined) {
                        //     dispatchSubheaderTextUpdate(dispatch, {
                        //         info: data.design,
                        //         title: collectionName.name,
                        //         note: null
                        //     });
                        // }; 
                        // setIsLoaded(true);
                    }
                } else {
                    // hasFetchError = true;
                }
            })
            .catch(error => {
                console.log(error); 
            }); 
            
        };

        if (articlesIDs.length > 0) {
            console.log('IDS', articlesIDs)
            let count = 0;
            articlesIDs.forEach(id => {
                count += 1;
                fetchArticlesData(id);
            });
            // if (!hasFetchError) {
            //     dispatchArticlesData(dispatch, articles);
            //     // dispatch({
            //     //     type:  'SET_ARTICLES',
            //     //     payload: userArticle
            //     // });
            // }
        }

        

        return () => {
            fetching = false;
        };
    }, [articlesIDs])

    useEffect(() => {
        setSubheaderTextInput(subheaderText);
    }, [subheaderText]);

    return (
        <div className='app'>
            <Header/>
            {
                isAppActive ? null : <DialogWindow />
            }
            {
                !_isArticleSelected ? <>
                    <NavBar
                        activeFilter={activeFilter}
                        updateFilter={updateFilter}
                    />
                    <SubHeader
                        subheaderTextInput={subheaderTextInput}
                    />
                    <div 
                        className='app-body' id='body'
                        onScroll={() => updateScrollTop()}
                    >
                        <ErrorBoundry>
                            <Gallery
                                scrollTop={scrollTop}
                            /> 
                        </ErrorBoundry>
                    </div>
                </> : <ErrorBoundry>
                    <ConfigManager/>
                </ErrorBoundry>
            } 
        </div>
    )
};
export default RodaApp;


